/**
 * Presentation Layer - DataPreviewHeader Component
 * データプレビューヘッダーコンポーネント
 */

import React from 'react';
import { Box, Button } from '@mui/material';
import type { DataDisplayMode } from '../hook/useDataPreview';

/**
 * Props定義
 */
export interface DataPreviewHeaderProps {
  /** 表示件数 */
  totalCount: number;
  /** 現在の表示モード */
  displayMode: DataDisplayMode;
  /** 表示モード切り替えコールバック */
  onToggleMode: (mode: DataDisplayMode) => void;
  /** 加工済みデータが存在するか */
  hasProcessedData?: boolean;
}

/**
 * データプレビューヘッダーコンポーネント
 * developブランチのデザインに合わせたシンプルな実装
 */
export const DataPreviewHeader: React.FC<DataPreviewHeaderProps> = ({
  totalCount,
  displayMode,
  onToggleMode,
  hasProcessedData = false,
}) => {
  /**
   * モード切り替えハンドラ
   */
  const handleToggle = () => {
    const newMode: DataDisplayMode = displayMode === 'processed' ? 'original' : 'processed';
    onToggleMode(newMode);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {hasProcessedData && (
        <Button
          size="small"
          onClick={handleToggle}
          variant={displayMode === 'processed' ? 'contained' : 'outlined'}
        >
          {displayMode === 'processed' ? '加工済み' : '元データ'}
        </Button>
      )}
    </Box>
  );
};
